import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Context } from '../index';

const PrivateRoute = () => {
    const { store } = useContext(Context);

    if (!store.isAuth) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
